import { SortInput } from 'components/Table'
import { BuildOrderSortBy } from './hooks/useGetBuildOrders'

export const DEFAULT_SORT: SortInput<BuildOrderSortBy> = {
  by: 'updatedAt',
  direction: 'desc',
} as const

export const SORTABLE_COLUMNS: BuildOrderSortBy[] = ['updatedAt', 'domain.name']
